export default "__VITE_ASSET__9eRvPSFl__"